import { z } from 'zod';
/**
 * Widget Goal REST DTO — Phase 5 / Plan 05-02 (WIDGET-05).
 *
 * 엔드포인트:
 *   - `POST   /api/v1/widgets/me/goal`              — active goal 생성 (스트리머 전용)
 *   - `GET    /api/v1/widgets/:streamerId/goal/active` — 현재 active goal 조회 (공개)
 *   - `PATCH  /api/v1/widgets/me/goal/:id`          — title / targetKrw / endsAt 수정
 *   - `DELETE /api/v1/widgets/me/goal/:id`          — 종료 (active=false, row 는 보존)
 *
 * 불변 (05-02-PLAN Task 3 <behavior>):
 *   - 스트리머 당 active=true goal 은 최대 1개 (DB partial unique index 가 강제).
 *   - current_krw 는 클라이언트가 직접 수정 불가 (PATCH 허용 필드에서 제외 — T-05-10).
 *   - DELETE 는 DB row 삭제 금지 (audit trail — T-05-12).
 */
/** POST request body — 신규 goal 생성. */
export const createWidgetGoalRequestSchema = z.object({
    title: z.string().min(1).max(200),
    /**
     * 목표 금액 (KRW). 1원 이상. max 는 1억 — 현실적 상한. DB check `target_krw > 0`.
     * 스키마는 bigint 대응이 안 되므로 number — 1억 이하 범위에서 안전.
     */
    targetKrw: z.number().int().positive().max(100_000_000),
    /** 종료 시각 (optional, ISO 8601). 생략 시 무기한. */
    endsAt: z.string().datetime({ offset: true }).nullable().optional(),
});
/** PATCH request body — 부분 수정. currentKrw 는 **금지** (서버 원자 증가만 허용). */
export const patchWidgetGoalRequestSchema = z
    .object({
    title: z.string().min(1).max(200).optional(),
    targetKrw: z.number().int().positive().max(100_000_000).optional(),
    endsAt: z.string().datetime({ offset: true }).nullable().optional(),
})
    .refine((v) => v.title !== undefined || v.targetKrw !== undefined || v.endsAt !== undefined, { message: '수정할 필드가 최소 1개 필요합니다' });
/** Goal 응답 단위 — create / get / patch 공용. */
export const widgetGoalResponseSchema = z.object({
    id: z.string().uuid(),
    streamerId: z.string().uuid(),
    title: z.string().min(1).max(200),
    /** number 로 직렬화 (JSON spec). 1억 이하이므로 안전. */
    targetKrw: z.number().int().nonnegative(),
    currentKrw: z.number().int().nonnegative(),
    startsAt: z.string().datetime({ offset: true }),
    endsAt: z.string().datetime({ offset: true }).nullable(),
    reachedAt: z.string().datetime({ offset: true }).nullable(),
    active: z.boolean(),
});
/** GET active 응답 — active goal 없으면 null. */
export const getActiveWidgetGoalResponseSchema = widgetGoalResponseSchema.nullable();
//# sourceMappingURL=widget-goal.rest.js.map